export default {"src":"/_next/static/media/wellnes.37eb921a.svg","height":29,"width":26,"blurWidth":0,"blurHeight":0};